export default "__VITE_ASSET__Cs69Twpp__"